import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constant } from '../shared/constants';
import { Utils } from '../shared/utils';
import { REF_ACCOUNTS_SECURITIES_FLAG, RefAccountsSecuritiesRequest } from '../models/admin-model';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(private _httpClient: HttpClient) { }

  search(application: string): Observable<RefAccountsSecuritiesRequest[]> {
    const request: Partial<RefAccountsSecuritiesRequest> = {
      Flag: REF_ACCOUNTS_SECURITIES_FLAG.SEARCH,
      application
    };
    return this._httpClient
      .post<RefAccountsSecuritiesRequest[] | RefAccountsSecuritiesRequest | null>(Constant.uri.refAccountsSecurities, request, Utils.getHttpOptions())
      .pipe(map(res => {
        const arr = Array.isArray(res) ? res : (res ? [res] : []);
        return arr.map(item => this.normalize(item));
      }));
  }

  // Backend returns InactiveDate (PascalCase) as an ISO date-time; normalize the key and format to MM/dd/yyyy.
  private normalize(item: any): RefAccountsSecuritiesRequest {
    const raw = item.inactiveDate ?? item.InactiveDate ?? null;
    const application = item.application ?? item.Application ?? '';
    const normalizedApplication = application
      ? String(application).toUpperCase()
      : application;
    return {
      ...item,
      application: normalizedApplication,
      inactiveDate: this.toDisplayDate(raw)
    };
  }

  private toDisplayDate(value: string | null): string | null {
    if (!value) {
      return null;
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return null;
    }
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${mm}/${dd}/${d.getFullYear()}`;
  }

  addItem(item: RefAccountsSecuritiesRequest): Observable<RefAccountsSecuritiesRequest> {
    const request: RefAccountsSecuritiesRequest = { ...item, Flag: REF_ACCOUNTS_SECURITIES_FLAG.INSERT };
    return this._httpClient.post<RefAccountsSecuritiesRequest>(Constant.uri.refAccountsSecurities, request, Utils.getHttpOptions());
  }

  updateItem(item: RefAccountsSecuritiesRequest): Observable<RefAccountsSecuritiesRequest> {
    const request: RefAccountsSecuritiesRequest = { ...item, Flag: REF_ACCOUNTS_SECURITIES_FLAG.UPDATE };
    return this._httpClient.post<RefAccountsSecuritiesRequest>(Constant.uri.refAccountsSecurities, request, Utils.getHttpOptions());
  }

  // Soft delete - backend flips isActive/inactiveDate, row is not physically removed.
  deleteItem(item: RefAccountsSecuritiesRequest): Observable<RefAccountsSecuritiesRequest> {
    const request: RefAccountsSecuritiesRequest = { ...item, Flag: REF_ACCOUNTS_SECURITIES_FLAG.DELETE };
    return this._httpClient.post<RefAccountsSecuritiesRequest>(Constant.uri.refAccountsSecurities, request, Utils.getHttpOptions());
  }
}

